import { render, staticRenderFns } from "./video-info.vue?vue&type=template&id=285db22b&scoped=true&"
import script from "./video-info.vue?vue&type=script&lang=js&"
export * from "./video-info.vue?vue&type=script&lang=js&"
import style0 from "./video-info.vue?vue&type=style&index=0&id=285db22b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285db22b",
  null
  
)

export default component.exports